export function getUserAvatarSrc(firstName, lastName) {
    return `https://ui-avatars.com/api/?name=${firstName} ${lastName}&size=128`;
}